export default {
  appName: "Cribbage",
  version: "3.15.5",
  debug: false,
  ios: '1362318446',
  android: 'com.jdsoftwarellc.cribbage',
  windows: '9ntj99b0pblj',
  amazon: 'B07BMRYW6D',
  webRateURL: 'https://g.page/r/CfKGerjowq36EBM/review',
  email: 'cribbage@jdsoftwarellc.com',
  emailsubject: 'Cribbage Feedback',
  os: null,
  shareUrl: 'https://cardsjd.com/cribbage/',
  shareTitle: 'Cribbage',
  shareText: "Let's play Cribbage",
  gamesUrl: 'https://cardsjd.com/config/moregames.json',
}